export const posts = [
  {
    slug: 'how-to-get-custom-metal-parts-made-ontario',
    title: 'How to Get Custom Metal Parts Made in Ontario (Without CAD Files)',
    description: 'Step-by-step guide to getting custom metal parts fabricated in Ontario using just a sketch — no CAD files or technical drawings required.',
  },
  {
    slug: 'custom-metal-fabrication-cost-canada',
    title: 'What Does Custom Metal Fabrication Cost in Canada? A Pricing Guide',
    description: 'A breakdown of what drives custom metal fabrication pricing in Canada, with rough cost ranges for brackets, shelving, prototypes, and HVAC fittings.',
  },
  {
    slug: 'how-to-prototype-metal-product-ontario',
    title: 'How to Prototype a Metal Product Idea in Ontario',
    description: 'A guide for inventors on turning a metal product idea into a working prototype in Ontario — methods, budgeting, and finding the right shop.',
  },
  {
    slug: 'sheet-metal-vs-cnc-machining',
    title: 'Sheet Metal vs CNC Machining: Which Do You Need?',
    description: 'A plain-language comparison of sheet metal fabrication and CNC machining — cost, speed, precision, and how to decide which process fits your part.',
  },
  {
    slug: 'what-we-got-wrong-in-month-one',
    title: 'What we got wrong in our first month',
    description: 'We spent a month advertising MetalMatch and got one lead. Here are the three things wrong with our own website, and what we changed.',
    // Not a how-to guide like the other four — it is a numbers post about our own
    // mistakes, so the index and the page header label it differently.
    kind: 'field note',
  },
];
